import { Component, OnInit, Input, ElementRef, inject, output, viewChild } from '@angular/core';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { ColorComponentMixinBase } from '../../common-behavior/color';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'mulo-onboarding',
    templateUrl: './onboarding.component.html',
    styleUrls: ['./onboarding.component.scss'],
    inputs: ['color'],
    imports: [
        MatMenuTrigger,
        MatMenu,
        MatButton,
    ]
})
export class OnboardingComponent extends ColorComponentMixinBase
  implements OnInit {
  guideShowDelay: number = 600;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() text: string;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() align: 'left' | 'right' | 'center' = 'left';
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() textOffset: number;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() buttonText: string = 'Got it';
  readonly guideClosed = output();

  readonly guideTextTrigger = viewChild<MatMenuTrigger>('guideTextTrigger');

  constructor() {
    const elementRef = inject(ElementRef);

    super(elementRef);
  }

  ngOnInit() {
    setTimeout(() => {
      this.guideTextTrigger().openMenu();
    }, this.guideShowDelay);
  }

  onGuideTextClosed() {
    this.guideClosed.emit(null);
  }

  get offsetTextPosition() {
    let off = this.textOffset;
    return this.align === 'left' ? `-${off}rem` : `${off}rem`;
  }
}
